
import {mobile}         from './mobileCtrl'
import {viewAsyn}       from './viewAsynProcessing'
import { vaild }        from './validationCtrl.js'

import Provider         from '../../common/model/Provider.js'
import Config           from '../../common/model/Config'
import GlobalVar        from '../../common/model/GlobalVar.js'
import UmdOption        from '../../common/model/UmdOption.js'

import logo_pass        from '../../common/resource/img/logo_pass.png';
import logo_payco       from '../../common/resource/img/logo_payco.png';
import logo_kakao       from '../../common/resource/img/logo_kakao.png';
import logo_kakaopay    from '../../common/resource/img/logo_kakaopay.png';
import logo_kb          from '../../common/resource/img/logo_kb.png';
import logo_samsung     from '../../common/resource/img/logo_samsung.png';
import logo_naver       from '../../common/resource/img/logo_naver.png';
import logo_shinhan     from "../../common/resource/img/logo_shinhan.png";
import logo_toss        from '../../common/resource/img/logo_toss.png';
import logo_banksalad        from '../../common/resource/img/logo_banksalad.png';
import logo_sample      from '../../common/resource/img/logo_sample.png';

import {regex}          from '../../common/utils/regex'
import { device, deviceWBKHeight, deviceWBKWitdh }       from '../../common/utils/deviceCheck.js'
import { providerChk }  from '../../common/utils/provider.id.check.js'
import { mTransKey }    from '../../common/utils/mTransKeyEvt.js'

import {common}         from '../../common/controller/validationCtrl'
import { webAccess }    from '../../common/controller/webAccessibilityCtrl.js'

var rootId = "";
export const viewEvent = {
    init: ()=>{
        rootId = Config.appendElementTagId;
        viewEvent.reqeustFormEvents();
        vaild.inputSizeCheck();
        vaild.isSignedData();
    },    
    //In Popup Module View Template
    view_msg: (title, code, message, confirmEvent)=>{
        $(`${rootId} #view_err .tit`).text(title !== undefined ? title : "");
        $(`${rootId} #view_err .errerContent`).html(message !== undefined ? message : "");
        $(`${rootId} #view_err`).addClass("view");
        webAccess.targetFocus(`${rootId} #view_err .alert`);
        window.scrollTo(0,0);

        // Confirm/Close Button
        $(`${rootId} #view_err button`).off('click').on('click',()=>{
            $(`${rootId} #view_err`).removeClass("view");
            mobile.hide_agree_button();
            if(confirmEvent !== undefined){
                confirmEvent();
            }
        })
    },    
    view_msg_yn: (title, message, fnYEvent, fnNEvent)=>{
        $(`${rootId} #view_info .tit`).text(title !== undefined ? title : "");
        $(`${rootId} #view_info .errerContent`).html(message !== undefined ? message : "");
        $(`${rootId} #view_info`).addClass("view");
        webAccess.targetFocus(`${rootId} #view_info .alert`);
        window.scrollTo(0,0);

        $(`${rootId} #view_info .view-y`).off('click').on('click',()=>{
            $(`${rootId} #view_info`).removeClass("view");
            if(fnYEvent !== undefined){
                fnYEvent();
            }
        })
        $(`${rootId} #view_info .view-n`).off('click').on('click',()=>{
            $(`${rootId} #view_info`).removeClass("view");
            if(fnNEvent !== undefined){
                fnNEvent();
            }
        })
    },
    view_wait_provider: ()=>{
        const providerId = Provider.providerId;
        viewEvent.showStep2();
        $(`${rootId} .csTxt`).removeClass("view");
        function render(title,logo){
            $(`${rootId} .m_icon .logoBox img`).attr("src", logo);
            $(`${rootId} .m_icon .logoBox img`).attr("alt", title);
            $(`${rootId} #provider_icon_url`).attr("src", logo);
            $(`${rootId} #provider_icon_url`).attr("alt", title);
            $(`${rootId} .serviceName`).text(title+" 인증서");
        }

        if(providerChk.isPass(providerId)){
            render("통신사",logo_pass)
            $(`${rootId} #div_pass`).addClass("view");
        }else if(providerChk.isKb(providerId)){
            render("KB모바일",logo_kb)
            $(`${rootId} #div_kb`).addClass("view");
        }else if(providerChk.isSamsung(providerId)){
            render("삼성패스",logo_samsung)
            $(`${rootId} #div_kica`).addClass("view");
        }else if(providerChk.isKakao(providerId)){
            render("카카오톡",logo_kakao)
            $(`${rootId} #div_kakao`).addClass("view");
        }else if(providerChk.isKakaoPay(providerId)){
            render("카카오페이",logo_kakaopay)
            $(`${rootId} #div_kakaopay`).addClass("view");
        }else if(providerChk.isPayco(providerId)){
            render("페이코",logo_payco)
            $(`${rootId} #div_payco`).addClass("view");
        }else if(providerChk.isNaver(providerId)){
            render("네이버",logo_naver)
            $(`${rootId} #div_naver`).addClass("view");
        } else if (providerChk.isShinhan(providerId)) {
            render("신한", logo_shinhan);
            $(`${rootId} #div_shinhan`).addClass("view");
        }else if(providerChk.isToss(providerId)){
            render("토스",logo_toss)
            $(`${rootId} #div_toss`).addClass("view");
        }else if(providerChk.isBanksalad(providerId)){
            render("뱅크샐러드",logo_banksalad)
            $(`${rootId} #div_banksalad`).addClass("view");
        }else if(providerChk.isHana(providerId)){
            render("하나",logo_banksalad)
            $(`${rootId} #div_hana`).addClass("view");
        }else{
            render(providerId,logo_sample);
        }
    },
    serviceSelect: ()=>{

        //각각의 동의항목 Enter Key 체크 이벤트
        $("#submitFm input[type=checkbox]").on('keydown',e=>{
            if(e.which === 13){
                $(e.currentTarget).click();
            }
        })
        //서비스 선택
        $(`${rootId} .serviceSelect .list li`).on('click',(e)=>{
            $(`${rootId} .serviceSelect .list li`).removeClass('selected');
            $(e.currentTarget).addClass('selected');
            $(`${rootId} .serviceSelect .list li`).removeAttr("title");
            $(e.currentTarget).attr("title","선택됨");
            Provider.providerId = $(e.currentTarget).find("input[name=provider]").val();

            if(Provider.compareCI == false && providerChk.isSamsung(Provider.providerId)){
                viewEvent.hideBirthSsn();
                mTransKey.close();
            }else{
                viewEvent.showBirthSsn();
            }

            /* if(providerChk.isNaver(Provider.providerId)){
                const naver = new naver_id_login(Config.provider.api.naver.clientId, Config.provider.api.naver.callbackUrl);
                naver.setState(Provider.txId);

                if(Provider.userInfo.access_token == ""){
                    var link = naver.getNaverIdLoginLink();
	                session.setModuleParams(ModuleParam.configPath, ModuleParam.json, ModuleParam.callback);
                    window.popup = window.open(link,'네이버 인증','location=no, directories=no,resizable=no,status=no,toolbar=no,menubar=no, width=480,height=560, right=0, top=0');
                } 
            } */

            //모바일 환경에서만 동작
            if(device.isMobileUI()){
                if(providerChk.isPass(Provider.providerId)){
                    $(`${rootId} .telecom`).show();
                    $(`${rootId} .none-telecom`).hide();
                    if($(`${rootId} [data-id='oacx_phone3']`).val() == ""){
                        var pv = $(`${rootId} [data-id='oacx_phone3']`).val();
                        $(`${rootId} [data-id='oacx_phone3']`).val(pv);
                    }
                }else{
                    $(`${rootId} .telecom`).hide();
                    $(`${rootId} .none-telecom`).show();
                    if($(`${rootId} [data-id='oacx_phone2']`).val() == ""){
                        var pv = $(`${rootId} [data-id='oacx_phone2']`).val();
                        $(`${rootId} [data-id='oacx_phone2']`).val(pv);
                    }
                }

                var provider_txt = $(e.currentTarget).find("p.m_txt").attr("data-txt");
                $(`${rootId} .selectedService dd`).text(provider_txt+" 인증서");
                $(`${rootId} .selectedService`).show()
            
                //인증완료 대기화면 인증기관 메시지
                $(`${rootId} #msg_kica`).hide();
                if(providerChk.isSamsung(Provider.providerId)){
                    $(`${rootId} #msg_kica`).show();
                }
                
                //입력 Form Check
                if(mobile.isAllFormValue()){
                    //개인정보 동의
                    mobile.nextView();
                }else{
                    webAccess.targetFocus(`${rootId} [data-id='oacx_name']`)
                    /* if(!providerChk.isNaver(Provider.providerId)){
                        webAccess.targetFocus(`${rootId} [data-id='oacx_name']`)
                    } */
                }
            }else{
                webAccess.targetFocus(`${rootId} [data-id='oacx_name']`)
                /* if(!providerChk.isNaver(Provider.providerId)){
                    webAccess.targetFocus(`${rootId} [data-id='oacx_name']`)
                } */
            }
            
        })

        
        //네이버 자동 선택
        /* var access_token = locationObj.getHashByName(location.href, "access_token");
        if(access_token != ""){
            $(`${rootId} .serviceSelect .list li`).removeClass("selected");
            $(`${rootId} .serviceSelect .list li`).each((index,item)=>{
                var providerId = $(item).find("input[name=provider]").val();
                if(providerChk.isNaver(providerId)){
                    $(item).click();
                }
                
            })
        } */
    },
    successEventHandler: (callback)=> {
        //인증완료
        $(`${rootId} #step2Success`).on('click',()=>{
            viewAsyn.finishAuth(callback);
        })
    },
    reqeustFormEvents: ()=>{

        //개인정보이용동의(필수)
        $(`${rootId} #policy1_btn, ${rootId} #m_policy1_btn`).on('click',()=>{
            $(`${rootId} #view_policy1`).addClass("view");
            webAccess.targetFocus(`${rootId} #view_policy1 .policy .cont`);
        })
        //서비스이용약관동의(필수)
        $(`${rootId} #policy2_btn, ${rootId} #m_policy2_btn`).on('click',()=>{
            $(`${rootId} #view_policy2`).addClass("view");
            webAccess.targetFocus(`${rootId} #view_policy2 .policy .cont`);
        })
        //제3자 정보제공동의(필수)
        $(`${rootId} #policy3_btn, ${rootId} #m_policy3_btn`).on('click',()=>{
            $(`${rootId} #view_policy3`).addClass("view");
            webAccess.targetFocus(`${rootId} #view_policy3 .policy .cont`);
        })
        //고유식별정보처리동의(필수)
        $(`${rootId} #policy4_btn, ${rootId} #m_policy4_btn`).on('click',()=>{
            $(`${rootId} #view_policy4`).addClass("view");
            webAccess.targetFocus(`${rootId} #view_policy4 .policy .cont`);
        })
        //다른서비스는 없나요
        $(`${rootId} #otherSrv`).on('click',()=>{
            $(`${rootId} #view_otherSrv`).addClass("view");
            webAccess.targetFocus(`${rootId} #view_otherSrv .alert`);
            
        })

        //통신사 선택
        if(!$(`${rootId} [data-id='oacx_phone0']`).is("option:not([disabled=disabled])")){
            $(`${rootId} [data-id='oacx_phone0']`).css("color","rgb(77, 77, 77)");
        }
        $(`${rootId} [data-id='oacx_phone0']`).on('change',(e)=>{
            if(!$(e.currentTarget).is("option:not([disabled=disabled])")){
                $(`${rootId} [data-id='oacx_phone0']`).css("color","#4d4d4d");
            }else{
                $(`${rootId} [data-id='oacx_phone0']`).css("color","rgba(55, 59, 64, 0.3)");
            }
        })

        //주민번호 뒷자리 보이기/안보이기
        $(`${rootId} .togle_view`).on('click',(e)=>{
            if(device.isMobileUI()){
                if($(e.currentTarget).is(".on")){
                    $(e.currentTarget).attr("title","주민등록번호 뒷자리 숨김")
                    $(`${rootId} [data-id='oacx_num2']`).attr("type","password");
                    $(`${rootId} [data-id='oacx_num2']`).css("-webkit-text-security","disc");
                    $(e.currentTarget).removeClass("on");
                }else{
                    $(`${rootId} [data-id='oacx_num2']`).attr("type","number");
                    $(`${rootId} [data-id='oacx_num2']`).css("-webkit-text-security","none");
                    $(e.currentTarget).addClass("on");
                    $(e.currentTarget).attr("title","주민등록번호 뒷자리 표시")
                }
            }else{
                //pc, tablet
                if($(e.currentTarget).is(".on")){
                    $(e.currentTarget).attr("title","주민등록번호 뒷자리 숨김")
                    $(`${rootId} [data-id='oacx_num2']`).attr("type","password");
                    $(`${rootId} [data-id='oacx_num2']`).css("-webkit-text-security","disc");
                    $(e.currentTarget).removeClass("on");
                }else{
                    $(`${rootId} [data-id='oacx_num2']`).attr("type","number");
                    $(`${rootId} [data-id='oacx_num2']`).css("-webkit-text-security","none");
                    $(e.currentTarget).addClass("on");
                    $(e.currentTarget).attr("title","주민등록번호 뒷자리 표시")
                }
            }
        })

        if(Config.id == "sign"){
            // $(`${rootId} .signView`).show();
            //서명 전문보기
            $(`${rootId} #signOrigin`).on('click',()=>{
                $(`${rootId} #view_sign_origin .cont `).html(Provider.contentInfo.signTarget);
                $(`${rootId} #view_sign_origin`).addClass("view");
                $(`${rootId} #view_sign_origin`).css("font-size","13px")
            })
        }

        //popup 닫기
        $(`${rootId} .alertArea button`).on('click',(e)=>{
            $(`${rootId} .alertArea`).removeClass("view");
        })
        $(`${rootId} .viewPop button`).on('click',(e)=>{
            $(`${rootId} .viewPop`).removeClass("view");
        })

        //서비스 시용에 대한 전체동의 이벤트
        $(`${rootId} #oacx_total`).on('click',(e)=>{
            if($(e.currentTarget).prop("checked")){
                $(`${rootId} .pcAgree input[type=checkbox]:not('#oacx_total')`).prop("checked",true);
            }else{
                $(`${rootId} .pcAgree input[type=checkbox]:not('#oacx_total')`).prop("checked",false);
            }
        })
        //개별 동의 체크 항목
        $(`${rootId} #oacx_policy1, ${rootId} #oacx_policy2, ${rootId} #oacx_policy3, ${rootId} #oacx_policy4`).on('click',(e)=>{
            var isAllChk = false;
            var chkBxArr = $(`${rootId} .pcAgree input[type=checkbox]:not(#oacx_total)`);
            chkBxArr.each(function(i,elem){
                if($(elem).prop("checked")){
                    isAllChk = true;
                }else{
                    isAllChk = false;
                    return false;
                }
            })
            if(isAllChk){
                $(`${rootId} #oacx_total`).prop("checked",true);
            }else{
                $(`${rootId} #oacx_total`).prop("checked",false);
            }
        })

        //사용안내
        $(`${rootId} .info`).on('click',()=>{
            const path = Config.file.guide.path;
            window.open(path,'간편인증 사용방법 안내','location=no, directories=no,resizable=no,status=no,toolbar=no,menubar=no, width=1200,height=720, right=0, top=0');
        })

        //인증요청
        $(`${rootId} #step1Request`).on('click',()=>{
            viewEvent.formValidation_popup();
        })

        //취소
        $(`${rootId} .popup-close`).on('click',(e)=>{
            viewEvent.closePopup();
            UmdOption.callback.event.close();
            if(GlobalVar.closeEvt !== undefined){
                const closeEvt = GlobalVar.closeEvt
                closeEvt(e);
            }
        })
    }, 
    formValidationCheck: ()=>{
        const name = common.trim($(`${rootId} [data-id='oacx_name']`).val());
        const num1 = common.trim($(`${rootId} [data-id='oacx_num1']`).val());
        const num2 = common.trim($(`${rootId} [data-id='oacx_num2']`).val());
        const birth = common.trim($(`${rootId} [data-id='oacx_birth']`).val());
        const providerId =$(`${rootId} #submitFm .serviceSelect .list li.selected input[name=provider]`).val();
        var phone = common.trim($(`${rootId} [data-id='oacx_phone2']`).val());
        var telcoTycd = null;

        if(providerId === undefined || providerId == ""){
            $(`${rootId} input`).blur();
            viewEvent.view_msg("안내","","인증서비스를 선택하여 주십시오.", ()=>{
                $(`${rootId} input`).blur();
                // $(`${rootId} .main section`).scrollTop(0,0);
                webAccess.targetFocus(`${rootId} #oacx_providerList li:first-child a`)
            });
            return false;
        }
        if(!vaild.nameCheck(name)){
            return false;
        }

        if(Provider.isBirth){
            if(!vaild.birthCheck(birth)){
                return false;
            }
        }else{
            if(!vaild.ssCheck(num1,num2)){
                return false;
            }
        }

        if(device.isMobileUI()){
            if(providerChk.isPass(providerId)){
                phone = common.trim($(`${rootId} [data-id='oacx_phone3']`).val());
                var selected = $(`${rootId} [data-id='oacx_phone0'] option:not([disabled=disabled]):selected`).val();
                telcoTycd = selected === undefined ? null: selected;
    
                if(!vaild.telcoTycdCheck()){
                    return false;
                }
            }
        }
        
        if(!vaild.phoneCheck(phone, providerId)){
            return false;
        }

        //PC, Tablet 환경에서만 작동
        if(!device.isMobileUI()){
            if(!vaild.checkBoxVaild()){
                return false;
            }
        }

        //개인정보 이용 동의 확인 여부
        Provider.userInfo.privacy = $(`${rootId} #m_policy1_btn`).length !=0 ? 1:0;
        //서비스 이용약관 동의 확인 여부
        Provider.userInfo.policy3 = $(`${rootId} #m_policy2_btn`).length !=0 ? 1:0;
        //제3자 정보제공약관 확인 여부
        Provider.userInfo.policy4 = $(`${rootId} #m_policy3_btn`).length !=0 ? 1:0;
        //고유식별정보처리 동의 확인 여부
        Provider.userInfo.terms = $(`${rootId} #m_policy4_btn`).length !=0 ? 1:0;
        
        const phoneNm = common.trim($(`${rootId} [data-id='oacx_phone1'] option:selected`).val());
        Provider.userInfo.name = name;
        Provider.userInfo.ssn1 = num1;
        Provider.userInfo.ssn2 = num2;
        Provider.userInfo.phone = phoneNm + phone;
        Provider.userInfo.birthday = Provider.isBirth ? birth : regex.convertBirthDay(num1,num2);
        Provider.userInfo.telcoTycd = telcoTycd;
        Provider.providerId = providerId;
        Provider.provider = providerId + Config.provider.separator + Config.provider.version;
        return true;
    },
    formValidation_popup: ()=> {
        mTransKey.close();
        
        if(!viewEvent.formValidationCheck()){
            return false;
        }
        if(device.isMobileUI()){
            //개인정보 동의
            mobile.nextView();
        }else{
            //인증요청
            viewAsyn.requestAuth();
        }
    },
    closePopup: ()=>{
        mTransKey.close();
        $(`${rootId}`).html("");
        viewEvent.hideBackScreen();
    },
    hidePopup: ()=>{
        $(`${rootId} div.view`).removeClass("view");
    },
    showBackScreen: ()=>{
        $(`${rootId}`).append(`<div id="bgScrn"></div>`);
        $(`${rootId}`).show();
    },
    hideBackScreen: ()=>{
        $(`${rootId} #bgScrn`).remove();
    },
    showStep1: ()=>{
        $(`${rootId} #oacxEmbededContents`).show();
        $(`${rootId} .main-content`).show();
        $(`${rootId} .standby`).hide();
        $(`${rootId} .csTxt`).removeClass("view");
    },
    showStep2: ()=>{
        $(`${rootId} .main-content`).hide();
        $(`${rootId} .standby`).show();
        if(!$(`${rootId} .csTxt`).is(".view")){
            $(`${rootId} .csTxt`).addClass("view");
        }
    },
    showStepBtn: ()=>{
        $(`${rootId} #step1Request`).removeAttr("disabled");
        $(`${rootId} #step1Request`).removeClass("disabled");
        $(`${rootId} #step2Success`).removeAttr("disabled");
        $(`${rootId} #step2Success`).removeClass("disabled");
    },
    hideStepBtn: ()=>{
        $(`${rootId} #step1Request`).attr("disabled","disabled");
        $(`${rootId} #step1Request`).addClass("disabled");
        $(`${rootId} #step2Success`).attr("disabled","disabled");
        $(`${rootId} #step2Success`).addClass("disabled");
    },
    showBirthSsn: ()=>{
        $(`${rootId} .oacx-birth`).show();
        $(`${rootId} .oacx-ssn`).show();
    },
    hideBirthSsn: ()=>{
        $(`${rootId} .oacx-birth`).hide();
        $(`${rootId} .oacx-ssn`).hide();
    },
    setUserinfo: (json)=>{
        const {name, birth, phone, ss1} = json;
        $(`#oacxEmbededContents input[data-id="oacx_name"]`).val(name)
        $(`#oacxEmbededContents input[data-id="oacx_birth"]`).val(birth)
        $(`#oacxEmbededContents input[data-id="oacx_phone2"]`).val(phone)
        $(`#oacxEmbededContents input[data-id="oacx_num1"]`).val(ss1)
    },
    /* setResizeDevice(){
        $(window).off('resize').on('resize',function (e) {
            alert(`전체 ${screen.width} | ${$(window).width()} | ${deviceWBKWitdh}`)
            if($(window).width() === deviceWBKWitdh){
                return
            }
            if(screen.width == $(window).width() && $(window).width() !== deviceWBKWitdh){
                deviceWBKWitdh = $(window).width()
                viewEvent.view_msg("안내","","화면 전환을 감지했습니다. 정상적인 간편인증을 위하여 화면 종료 후 다시 실행해 주시기 바랍니다.",viewEvent.closePopup);
                return
            }else{
                deviceWBKWitdh = $(window).width()
                viewEvent.view_msg("안내","","화면 전환을 감지했습니다. 정상적인 간편인증을 위하여 화면 종료 후 다시 실행해 주시기 바랍니다.",viewEvent.closePopup);
                return
            }
        });
    } */
}